import { safe } from '$lib/utils/string';
import { ImmSearchParams } from '$lib/utils/url/ImmSearchParams';

export function resolveRoutePathWithVariables(
    routeId: string,
    params: Record<string, string | undefined>,
): string {
    const parts = routeId
        .split('/')
        .filter((part) => !(part.startsWith('(') && part.endsWith(')')))
        .map((part) => {
            return part.replaceAll(
                /\[?\[(\.\.\.)?([a-zA-Z_][a-zA-Z0-9_]*)(=([a-zA-Z_][a-zA-Z0-9_]*))?]]?/g,
                function (match, _p1, p2) {
                    if (p2 != null && typeof p2 === 'string') {
                        return params[p2] ?? '';
                    } else {
                        return '';
                    }
                },
            );
        })
        .filter((part) => part !== '');

    return `/${parts.join('/')}`;
}

export function recordToSearchParams(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    params: Record<string, any> | undefined | null,
): ImmSearchParams {
    if (params == null) {
        return new ImmSearchParams();
    }

    let sp = new ImmSearchParams();

    for (const [key, value] of Object.entries(params)) {
        if (value != null) {
            if (typeof value === 'string' || typeof value === 'number') {
                sp = sp.withSet(key, safe`${value}`);
            } else if (typeof value === 'boolean') {
                sp = sp.withSet(key, value ? 'true' : 'false');
            } else {
                sp = sp.withSet(key, JSON.stringify(value));
            }
        }
    }

    return sp;
}

export function extractRouteParams(routeId: string) {
    const params = [
        ...routeId.matchAll(
            /\[?\[(\.\.\.)?([_a-zA-Z][_a-zA-Z0-9]*)([=][_a-zA-Z][_a-zA-Z0-9]*)?]]?/g,
        ),
    ].map((g) => ({
        optional: g[0].startsWith('[[') && g[0].endsWith(']]'),
        name: g[2],
    }));

    const res: string[] = [];
    for (const param of params) {
        if (param.optional) {
            res.push(`${param.name}?: string|null|undefined`);
        } else {
            res.push(`${param.name}: string`);
        }
    }

    if (res.length === 0) {
        return `Record<string, never>`;
    }

    return `{${res.join(', ')}}`;
}
